import { mapGetters } from 'vuex';
export const mixin = {
    data() {
        return {
            processing: false
        }
    },
    computed: {
        ...mapGetters(['user', 'person']),
        inProgress() {
            return this.processing;
        }
    },
    methods: {
        startProcessing() {
            this.processing = true;
        },
        stopProcessing() {
            this.processing = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixin.js